import classNames from 'classnames'
import { ElementType, forwardRef, HTMLAttributes, JSX, PropsWithChildren } from 'react'

import { splitSprinkleProps } from '@/styles/split-sprinkle-props'

import { sprinkles, Sprinkles } from '@/styles/sprinkles.css'

export const Box = forwardRef<HTMLDivElement, BoxProps>(function Box(props, ref) {
  const [sprinkleProps, { as = 'div', className, style, inline, children, ...restProps }] = splitSprinkleProps<BoxProps>(props)
  const display = inline ? 'inline-block' : 'block'
  const As = as as ElementType
  return (
    <As
      ref={ref}
      style={style}
      className={classNames(sprinkles({ ...sprinkleProps, display }), className)}
      {...restProps}
    >
      {children}
    </As>
  )
})

export interface BoxProps extends Omit<Sprinkles, 'display'>, PropsWithChildren, Omit<HTMLAttributes<HTMLElement>, keyof Sprinkles> {
  as?: keyof JSX.IntrinsicElements
  inline?: boolean
}
